// extracted by mini-css-extract-plugin
module.exports = {"header":"WorkspacesBox_header__2TVnt","box":"WorkspacesBox_box__3AxiN","node":"WorkspacesBox_node__7oWv9"};